export function money(value: number | string | null | undefined, currency = "RUB"): string {
  const number = typeof value === "number" ? value : Number(value ?? 0);
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency,
    maximumFractionDigits: 0
  }).format(Number.isFinite(number) ? number : 0);
}

export function dateShort(value: string | null | undefined): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("ru-RU", { day: "numeric", month: "long" });
}

export function initials(name: string | null | undefined): string {
  const source = (name || "Пользователь").trim();
  return source.slice(0, 1).toUpperCase();
}

export function normalizeArray(value: unknown): string[] {
  if (Array.isArray(value)) return value.filter((item): item is string => typeof item === "string");
  if (typeof value === "string" && value.trim()) return value.split(",").map((item) => item.trim()).filter(Boolean);
  return [];
}
